import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=6e2b07d4"
import script from "@/js/searchResult.ts?vue&type=script&lang=ts&external"
export * from "@/js/searchResult.ts?vue&type=script&lang=ts&external"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=6e2b07d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports